import { useState, useContext, useEffect } from "react";
import { nanoid } from "nanoid";

import { TopWinnerwinItem } from "./topWinnerwinItem.jsx";
import { LeaderboardContext } from "../../provider/leaderboard";

import "./index.scss";

const TopWinnerwinner = (props) => {
  const { searchInput, setSearchInput, filteredTopWinnerResult } =
    useContext(LeaderboardContext);
  const [topResult, setTopResult] = useState([]);

  useEffect(() => {
    setTopResult(filteredTopWinnerResult);
    if (searchInput) {
      const filtered = topResult.filter((res) => {
        return res.user_wallet.toLowerCase().includes(searchInput);
      });
      setTopResult(filtered);
    } else {
      setTopResult(filteredTopWinnerResult);
    }
  }, [searchInput, filteredTopWinnerResult]);

  return (
    <>
      {topResult.length > 0 ? (
        topResult.map((res, index) => (
          <div key={nanoid()}>
            <TopWinnerwinItem index={index} leaderboard={res} />
          </div>
        ))
      ) : (
        <div className="no-result">
          <p>No result found...</p>
        </div>
      )}
    </>
  );
};

export default TopWinnerwinner;
